import { IsInt, IsObject, IsOptional, IsString, Max, Min } from "class-validator";
import { Type } from "class-transformer";
import {
    CreateGameInDTO as BaseCreateGameInDTO,
    StartGameInDTO as BaseStartGameInDTO,
    ProcessActionInDTO as BaseProcessActionInDTO,
    ProcessActionOutDTO as BaseProcessActionOutDTO,
    GameSessionChallengeDTO as BaseGameSessionChallengeDTO,
    GetNextChallengeOutDTO as BaseGetNextChallengeOutDTO,
    GetNextChallengeInDTO as BaseGetNextChallengeInDTO,
    GameSessionResultDTO as BaseGameSessionResultDTO,
    GameSessionChallengeResultDTO as BaseGameSessionChallengeResultDTO
} from "../../types"

export class CreateGameInCharacterDTO {
    @IsString()
    symbol: string;

    /**
     * Опционально, можно будет прослушать произношение
     */
    @IsOptional()
    @IsString()
    pinyin?: string;

    /**
     * Перевод иероглифа
     */
    @IsOptional()
    @IsString()
    definition?: string;
}

export class CreateGameConfigDTO extends BaseCreateGameInDTO {
    /**
     * Количество иероглифов. Работает только в случае, если нужен рандом
     */
    @IsOptional()
    @IsInt()
    @Max(20)
    count?: number;

    @IsOptional()
    @IsInt()
    @Min(2)
    minStrokes?: number;

    @IsOptional()
    @IsInt()
    @Min(64)
    maxStrokes?: number;

    /**
     * Если не указано, то будет рандомиться
     */
    @IsOptional()
    @Type(() => CreateGameInCharacterDTO)
    characters?: CreateGameInCharacterDTO[];
}

export class CreateGameInDTO extends BaseCreateGameInDTO {
    config: CreateGameConfigDTO
}

export class StartGameInDTO extends BaseStartGameInDTO {}
export class ProcessActionInDTO extends BaseProcessActionInDTO {
    @IsObject()
    action: {
        type: 'select_variant',
        data: {
            count: number,
            challengeId: string,
        }
    };
}

export class GameSessionChallengeStateDTO {
    completed: boolean;
}

export class GameSessionChallengeDTO extends BaseGameSessionChallengeDTO {
    symbol: string;
    strokes: string[];
    state: GameSessionChallengeStateDTO = {
        completed: false,
    };
    variants: number[];
}

export class ProcessActionOutDTO extends BaseProcessActionOutDTO {
    nextChallenge?: GameSessionChallengeDTO;
    state: GameSessionChallengeStateDTO = { completed: false }
}


export class NextChallengeOutDTO extends BaseGetNextChallengeOutDTO {
    nextChallenge?: GameSessionChallengeDTO;
    state: GameSessionChallengeStateDTO = { completed: false };
}

export class NextChallengeInDTO extends BaseGetNextChallengeInDTO {
    nextChallenge?: GameSessionChallengeDTO;
}

export class GameSessionChallengeResultDTO extends BaseGameSessionChallengeResultDTO {
    data: {
        symbol: string;
        graphical: {
            strokes: string[],
            medians: [number, number][][],
        }
    }
}

export class GameSessionResultDTO extends BaseGameSessionResultDTO {
    challenges: GameSessionChallengeResultDTO[];
}
